/**
 * Subscription tier definitions — mirrored from backend SUBSCRIPTION_TIERS.
 * Used for display purposes (pricing table, usage meters, upgrade prompts).
 */

export const TIERS = {
  free: {
    name: 'Free',
    monthlyPrice: 0,
    annualPrice: null,
    threads: 1,
    sessionsPerMonth: 0,
    activeAssignments: 1,
    historyRetentionDays: 30,
    patterns: 'Basic',
    features: ['Full onboarding & discovery', 'Your first Deep Rest, made from your onboarding', '7 days of daily planning', 'Read your history & insights', 'Start a 14-day Pro trial anytime'],
  },
  pro: {
    name: 'Pro',
    monthlyPrice: 25,
    annualPrice: 19,
    annualTotal: 228,
    threads: null,
    sessionsPerMonth: 30,
    activeAssignments: null,
    historyRetentionDays: 365,
    patterns: 'Full + cross-thread',
    features: ['Deep Rest every day: evening Rest or morning Prime, your pick', '8 Deep Rests on demand each month, whole-life or one area', 'Original music bank, your choice of voice, downloads', 'Unlimited threads', '30 sessions/month', 'Unlimited assignments', 'Daily planning + evening review', 'Unlimited daily actions', 'Full streak tracking', '1-year history', 'Full + cross-thread patterns', 'Your Map', 'AI thematic insights', 'Voice chat (speak + listen)'],
  },
  entrepreneur: {
    name: 'Entrepreneur',
    monthlyPrice: 99,
    annualPrice: 79,
    annualTotal: 948,
    threads: null,
    sessionsPerMonth: null,
    activeAssignments: null,
    historyRetentionDays: null,
    patterns: 'Full + cross-thread',
    includesFrom: 'pro',
    highlights: [
      'Deep Rest twice a day: morning Prime and evening Rest',
      '20 Deep Rests on demand each month',
      'Claude Opus AI model',
      'Extended session memory (15 sessions)',
      'Weekly strategic briefing',
      'Business & Strategic Spaces',
      'Accountability partner',
      '90-day goal arcs',
    ],
    features: ['Unlimited sessions', 'Unlimited history'],
  },
};

export const TIER_ORDER = ['free', 'pro', 'entrepreneur'];

/**
 * Get the next tier to upgrade to from the current tier.
 */
export function getUpgradeTier(currentTier) {
  const idx = TIER_ORDER.indexOf(currentTier);
  if (idx < 0 || idx >= TIER_ORDER.length - 1) return null;
  return TIER_ORDER[idx + 1];
}

/**
 * Format a limit value for display (null = "Unlimited", number = number).
 */
export function formatLimit(value) {
  if (value === null || value === undefined) return 'Unlimited';
  return String(value);
}
